import React, { Component, Fragment } from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router";
import { COMPANY_TYPE } from 'constant';

import CartList from "./CartList";
import GoodsList from "./selectLists/GoodsList";
import GoodsListBanz from "./selectLists/GoodsListBanz";
import SelectDetail from "./selectLists/SelectDetail";
import "./index.scss";

@inject("commonStore", "orderStore")
@observer
class OrderContainer extends Component {
  state = {
    selectUser: null,
    selectGoods: null,
  };

  UNSAFE_componentWillMount() {
    this.props.orderStore.setCommonStoreInfo(this.props.commonStore);
    this.props.orderStore.onClear();
  }

  render() {
    const { sessionLoginInfo } = this.props.commonStore;
    const { selectGoods } = this.state;

    return (
      <Fragment>
        <div style={{ width: "100%", marginBottom: "10px", minHeight: "660px" }}>
          <div className={sessionLoginInfo?.cGbn === COMPANY_TYPE.BENZ
            ? (sessionLoginInfo?.deviceType === "Web" 
              ? "table_ord_step04_banz" : "table_ord_step06_banz")
            : (sessionLoginInfo?.deviceType === "Web" 
              ? "table_ord_step04" : "table_ord_step06")
          }>
            {sessionLoginInfo?.cGbn === COMPANY_TYPE.BENZ
            ? <GoodsListBanz
                detailGoods={selectGoods}
                onSelect={(data) => this.setState({ selectGoods: data })}
                cGbn={sessionLoginInfo?.cGbn || ""} 
              />
            : <GoodsList
                detailGoods={selectGoods}
                onSelect={(data) => this.setState({ selectGoods: data })}
                cGbn={sessionLoginInfo?.cGbn || ""} 
              />
            }
          </div>
          <div className="table_ord_step03">
            <SelectDetail
              cGbn={sessionLoginInfo?.cGbn || ""} 
              detailGoods={selectGoods}
              onSelect={() => this.setState({ selectGoods: null })}
            />
          </div>
        </div>
        <CartList 
          ceType={sessionLoginInfo?.ceType || ""} 
          cGbn={sessionLoginInfo?.cGbn || ""} 
        />
      </Fragment>
    );
  }
}

export default withRouter(OrderContainer);
